import _ from 'lodash'
import {
  ANALYTICS_CHANGE_CLIENT_FILTER,
  ANALYTICS_CHANGE_FILTER,
  ANALYTICS_FETCH,
  ANALYTICS_FETCH_BY_CASE_FAILED,
  ANALYTICS_FETCH_BY_CASE_SUCCESS,
  ANALYTICS_FETCH_FAILED,
  ANALYTICS_FETCH_SUCCESS,
} from './available'
import {RequestState} from "../../requestState";
import vue from 'vue'
import {di} from '../../application'

export default {
  [ANALYTICS_FETCH](state) {
    state.analytics.requestState = RequestState.Loading;
    state.analytics.response = {}
  },
  [ANALYTICS_FETCH_SUCCESS](state, response) {
    state.analytics.requestState = RequestState.Success;
    state.analytics.response = response
  },
  [ANALYTICS_FETCH_FAILED](state, error) {
    state.analytics.requestState = RequestState.Failed;
  },
  [ANALYTICS_FETCH_BY_CASE_SUCCESS](state, {caseId, response}) {
    if (!state.analytics.response || !state.analytics.response.items || state.analytics.response.items.length === 0) {
      return; // no analytics fetched
    }

    const newCase = response.items[0]; // we always set caseId filter, so single response
    const caseIndex = _.findIndex(state.analytics.response.items, it => it.caseId === caseId);

    if (caseIndex < 0) { // not presents in report
      return;
    }

    if (response.items.length === 0) { // remove affected services, but not case (otherwise UI will be broken)
      state.analytics.response.items[caseIndex].affectedServices.list = [];
    } else {
      vue.set(state.analytics.response.items, caseIndex, newCase); // update case
    }
  },
  [ANALYTICS_FETCH_BY_CASE_FAILED](state, error) {
    // no-op (show notification?)
  },
  [ANALYTICS_CHANGE_FILTER](state, filterDelta) {
    let resetToFirstPage = {}
    if (!filterDelta.pagination) { // not pagination change, so reset paging to first page
      resetToFirstPage = {
        pagination: {
          page: 1
        }
      }
    }

    let newFilter = _.mergeWith(state.analytics.filter, filterDelta, resetToFirstPage, (objValue, srcValue, key, object, source) => {
      if (_.isArray(srcValue)) {
        return srcValue
      }

      return undefined
    });

    state.analytics.filter = newFilter

    if (state.route.name === 'AnalyticsOverviewPage') {
      const filterAsString = JSON.stringify(state.analytics.filter);
      di.router.replace({
        name: 'AnalyticsOverviewPage',
        query: {
          filter: filterAsString
        }
      });
    }
  },
  [ANALYTICS_CHANGE_CLIENT_FILTER](state, filterDelta) {
    state.analytics.clientFilter = {...state.analytics.clientFilter, ...filterDelta}
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/analytics.js